'use client';

import type { FragmentType } from '~/shared/codegen/fragment-masking';
import { useFragment } from '~/shared/codegen/fragment-masking';
import ContentPlaceholder from '~/shared/components/content-placeholder';
import Link from '~/shared/components/link';
import { type Locale, PAGE_NAMES } from '~/shared/constants';
import { getLocaleLink } from '~/shared/helpers/browser-helpers';
import { getUrl } from '~/shared/helpers/string-helpers';

import { TopRatedCategoriesItemFragment } from '../blog-menu/helpers/blog-menu-cache';

type TopRatedCategoryItemProps = Readonly<{
  lng: Locale;
  error: boolean;
  loading: boolean;
  item: FragmentType<typeof TopRatedCategoriesItemFragment> | null;
}>;

const TopRatedCategoryItem = ({ closeDropdown, lng, error, loading, item }: TopRatedCategoryItemProps) => {
  const category = useFragment(TopRatedCategoriesItemFragment, item);

  return (
    <li className="top-rated-categories__list-item" key={category?._id}>
      <Link
        onClick={closeDropdown}
        itemProp="url"
        href={
          loading || !category?.alias
            ? '#'
            : getLocaleLink(
                getUrl({
                  link: PAGE_NAMES.CATEGORY,
                  alias: category.alias,
                }),
                lng,
              )
        }
      >
        <div className="top-rated-categories__bullet" />
        <div className="top-rated-categories__text">
          <ContentPlaceholder isLoading={loading} isError={error} content={category?.name} />
        </div>
      </Link>
    </li>
  );
};

export default TopRatedCategoryItem;
